import moment from 'moment';
import type { VoidFunctionComponent } from 'react';

import { useProjectLastPublished } from '../../../../hooks/api/projects/useProjectLastPublished';
import Loader from '../../../generic/Loader';

type Props = {
  // A revision or project locator for the issue dependency.
  locator: string;
};

/**
 * Displays issue details for Abandonware issues. Performs an async
 */
const AbandonwareDescription: VoidFunctionComponent<Props> = ({ locator }) => {
  const { data: value, error } = useProjectLastPublished(locator);

  // The issue should only exist if this value is populated, so we know it exists.
  const lastDate = (value) ? moment(value).format('MMMM Do, YYYY') : <Loader size={16} style={{ display: 'inline' }} />;
  return (
    <>
      <div>This package has not received any updates in over two years.</div>
      { !error && (
        <div>
          The last known update for this project was released{' '}
          <b>
            {lastDate}
          </b>
          .
        </div>
      )}
    </>
  );
};

export default AbandonwareDescription;
